// src/v2/pulse/LeaseCommitmentsBand.jsx
//
// Cost & commitments composition for the Pulse home. The lease exposure
// component owns its fetch, basis controls, and expansion state; this band
// only supplies the two-up placement and keeps the expanded detail full-width.

import { useState } from "react";
import { LeaseExposurePane } from "./LeaseExposurePane.jsx";
import { LeaseWindowsCalPane } from "./LeaseWindowsCalPane.jsx";

export function LeaseCommitmentsBand({ derivedLeases, onNavigate, locationScopeData }) {
  const [exposureVisible, setExposureVisible] = useState(true);

  return (
    <div
      className="v2-lease-commitments-row"
      data-testid="v2-lease-commitments-band"
      data-exposure-visible={exposureVisible ? "true" : "false"}
    >
      <LeaseExposurePane
        onNavigate={onNavigate}
        locationScopeData={locationScopeData}
        renderDetailOutside
        onVisibilityChange={setExposureVisible}
      />
      <LeaseWindowsCalPane
        derivedLeases={derivedLeases}
        onNavigate={onNavigate}
        twoUp
      />
    </div>
  );
}